
<Modal
    :show="isInMaintenance"
    :closeOnBackdropClick="false"
    size="small"
    title="TaxiFusion Wartung"
>
    <div class="maintenance-modal">
        <!-- Header -->
        <div class="maintenance-header">
            <p class="maintenance-subtitle">{{ maintenanceMessage }}</p>
        </div>

        <!-- Status Content -->
        <div class="maintenance-status-content">
            <!-- Countdown Timer -->
            <div v-if="timeUntilEnd" class="maintenance-timer-section">
                <div class="timer-header">
                    <i class="ri-time-line timer-icon"></i>
                    <span class="timer-label">Wir sind wieder online in:</span>
                </div>
                <div class="countdown-display">
                    <div class="countdown">{{ formatTime(timeUntilEnd) }}</div>
                    <div class="countdown-progress">
                        <div
                            class="progress-bar"
                            :style="{ width: progressPercentage + '%' }"
                        ></div>
                    </div>
                </div>
            </div>

            <!-- Checking Status -->
            <div
                v-else-if="isInMaintenance && !timeUntilEnd"
                class="maintenance-checking-section"
            >
                <div class="checking-content">
                    <i class="ri-loader-4-line spinning-icon"></i>
                    <p class="checking-text">Wartung läuft - Überprüfe Status...</p>
                </div>
            </div>

            <!-- Maintenance Window Info -->
            <div v-if="maintenanceWindow" class="maintenance-window-section">
                <div class="window-header">
                    <i class="ri-calendar-line window-icon"></i>
                    <span class="window-label">Geplante Wartungszeit:</span>
                </div>
                <div class="window-times">
                    <div class="time-item">
                        <span class="time-label">Von:</span>
                        <span class="time-value">{{
                            formatDateTime(maintenanceWindow.from)
                        }}</span>
                    </div>
                    <div class="time-item">
                        <span class="time-label">Bis:</span>
                        <span class="time-value">{{
                            formatDateTime(maintenanceWindow.to)
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</Modal>
